module.exports = __webpack_public_path__ + "static/media/personalized-feedback.e99df825.png";